/* Scroll functions */
(function( ) {
    'use strict'

    /* Setup */
    /* Setup */
    const events = {
        'viewport_ratio_changed': new CustomEvent(
            'viewport_ratio_changed',
            {
                'detail': {
                    'previousViewportRatio': () => last_vaspectratio,
                    'currentViewportRatio': () => vaspectratio
                }
            }
        ),
        'viewport_resized': new Event('viewport_resized')
    }
    let timeoutIds = {
            'viewport_ratio_changed': 0,
            'viewport_resized': 0
        },
        vw = 0,
        vh = 0,
        vaspectratio = '',
        last_vaspectratio = '',
        resize_timeout = false 

    /* Handle events */
    window.addEventListener( 'load' , () => {
        document.querySelector( 'body' ).classList.add( 'page-ready' )
    })
    window.addEventListener( 'resize' , () => {
        clearTimeout( resize_timeout )
        resize_timeout = setTimeout( () => {
            setViewportSizes(true)
            setBodyClasses(true)
            setViewportClasses(true)
        }, 250 )
        /* Dispatch event */
        clearTimeout(timeoutIds['viewport_resized'])
        timeoutIds['viewport_resized'] = setTimeout(() => { window.dispatchEvent(events['viewport_resized']) }, 250)
    })
    document.addEventListener( 'DOMContentLoaded', () => {
        document.querySelector( 'body' ).classList.add( 'dom-ready' )
        setViewportSizes()
        setBodyClasses()
        setViewportClasses()
    })

    function setViewportSizes(afterResize=false) {
        /* Setup */
        last_vaspectratio = vaspectratio
        
        /* Check viewport size */
        vw = Math.max( document.documentElement.clientWidth || 0, window.innerWidth || 0 )
        vh = Math.max( document.documentElement.clientHeight || 0, window.innerHeight || 0 )
        
        /* Get viewport aspect ratio */
        if ( vw > vh ) {
            vaspectratio = 'aspect-ratio-landscape'
        } else if ( vw < vh ) {
            vaspectratio = 'aspect-ratio-portrait'
        } else {
            vaspectratio = 'aspect-ratio-square'
        }

        /* Check for resize */
        if (
            afterResize == true &&
            last_vaspectratio != vaspectratio
        ) {
            /* Dispatch event */
            clearTimeout(timeoutIds['viewport_ratio_changed'])
            timeoutIds['viewport_ratio_changed'] = setTimeout(() => { window.dispatchEvent(events['viewport_ratio_changed']) }, 250)
        }
    }

    function setViewportClasses() {
        /* Set viewport class */
        if ( !document.querySelector( 'body' ).classList.contains( 'is-' + vaspectratio ) ) {
            document.querySelector( 'body' ).classList.remove( 'is-aspect-ratio-portrait' )
            document.querySelector( 'body' ).classList.remove( 'is-aspect-ratio-square' )
            document.querySelector( 'body' ).classList.remove( 'is-aspect-ratio-landscape' )
            document.querySelector( 'body' ).classList.add( 'is-' + vaspectratio ) 
        }

        /* Set media sizes */
        document.querySelectorAll( 'img, picture, source, video' ).forEach( ( elem ) => {
            elem.classList.remove( 'is-aspect-ratio-landscape', 'is-aspect-ratio-square', 'is-aspect-ratio-portrait' )

            if ( elem.width > elem.height ) {
                elem.classList.add( 'is-aspect-ratio-landscape' )
            } else if( elem.width < elem.height ) {
                elem.classList.add( 'is-aspect-ratio-portrait' )
            } else if( elem.width == elem.height ) {
                elem.classList.add( 'is-aspect-ratio-square' )
            }
        })
    }

    function setBodyClasses() {
        if ( !( 'ontouchstart' in document.documentElement ) ) {
            document.querySelector( 'body' ).classList.add( 'has-no-touch' )
            document.querySelector( 'body' ).classList.remove( 'has-touch' )
        } else {
            document.querySelector( 'body' ).classList.add( 'has-touch' )
            document.querySelector( 'body' ).classList.remove( 'has-no-touch' )
        }
    }
})( )